/**
 * Estandariza los controles sobre pantalla completa en el sitio. Cada vendor utiliza su propio prefijo para acceder
 * a las funciones de fullscren (moz, webkit o ms).
 * Es posible que el navegador tenga implementada la versión "estandar" (sin prefijo). Aún así se intentará cargar las
 * de webkit, moz y ms antes que la básica. Si estas no existiesen, se dejaría la versión original.
 */
export default function(){
    //Pollyfill para estandarizar las funciones de ir a pantalla completa
    Element.prototype.requestFullscreen = Element.prototype.webkitRequestFullscreen || Element.prototype.mozRequestFullscreen || Element.prototype.msRequestFullscreen || Element.prototype.requestFullscreen;

    //Pollyfill para estandarizar las funciones de salida de pantalla completa. Intentamos usar HTMLDocument (IE no lo hará.)
    if(typeof HTMLDocument !== 'undefined')
        HTMLDocument.prototype.exitFullscreen = document.mozCancelFullScreen || document.webkitExitFullscreen || document.msExitFullscreen || document.exitFullscreen;
    else
        Document.prototype.exitFullscreen = document.mozCancelFullScreen || document.webkitExitFullscreen || document.msExitFullscreen || document.exitFullscreen;


    //Pollyfill para detectar si estamos en pantalla completa
    if(!document.fullscreenElement){
        Object.defineProperty(document, 'fullscreenElement', {
            get: function() {
                return document.mozFullScreenElement || document.msFullscreenElement || document.webkitFullscreenElement
            }
        });
        Object.defineProperty(document, 'fullscreenEnabled', {
            get: function() {
                return document.mozFullScreenEnabled || document.msFullscreenEnabled || document.webkitFullscreenEnabled
            }
        });
    }
}